import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import {toast} from "react-toastify";
import moment from "moment";
import {
    resetNewCommunicationHistory,
    setNewClient,
    setNewCommunicationHistory
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import {setSaveNewClient} from "../../../../_reducers/activitySlice";
import {getOptionsByCommaString, isEmpty} from "../../../../_helpers/commonFunctions";
import DateBox from "../../../primer/DateBox";
import Dropdown from "../../../primer/Dropdown";
import EditableTable from "../../../primer/Editable-Table";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewClientCommunicationHistory = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const subjectsOptions = getOptionsByCommaString(CLIENTS_DATA.clientsSettings.clientCommunicationHistory);

    const communicationHistoryFilters = CLIENTS_DATA.newClient?.communicationHistoryFilters || {};

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [CLIENTS_DATA.newClient?.communicationHistory])

    const chColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "15px",
            editable: false,
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.date'),
            field: "date",
            width: "80px",
            editable: true,
            inputType: {
                type: 'datebox',
            }
        },
        {
            name: "Ώρα",
            field: "time",
            width: "50px",
            editable: true,
            inputType: {
                type: 'time',
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.subject'),
            field: "subject",
            width: "100px",
            editable: true,
            inputType: {
                type: 'dropdown',
                options: subjectsOptions
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.details'),
            field: "details",
            editable: true,
            width: "400px",
            inputType: {
                type: 'textarea',
            }
        },
    ]

    const handleOnFilterChange = (e, type = "default", ddname = '') => {
        const prepFilters = {...communicationHistoryFilters};

        let name;
        let value;
        if (type === "msdd") {
            name = ddname;
            value = e.flatMap((o) => o.value);
        } else if (type === "dd") {
            name = ddname;
            value = e.value;
        } else if (type === "dp") {
            value = e;
            name = ddname;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        prepFilters[name] = value;

        dispatch(setNewClient({...CLIENTS_DATA.newClient, communicationHistoryFilters: prepFilters}));
        setIncrKey(incrKey + 1);
    }

    const tableActions = {
        insert: (e, data) => {
            if (!ACTIVITY.saveNewClient) dispatch(setSaveNewClient(true));

            const tempCommunicationHistory = {...CLIENTS_DATA.newCommunicationHistory};
            tempCommunicationHistory[data.field] = data.value;
            dispatch(setNewCommunicationHistory(tempCommunicationHistory));
            if (tempCommunicationHistory && !isEmpty(tempCommunicationHistory.subject) && !isEmpty(tempCommunicationHistory.details) && tempCommunicationHistory.date && tempCommunicationHistory.time) {
                const cloneIt = structuredClone([tempCommunicationHistory, ...structuredClone(CLIENTS_DATA.newClient?.communicationHistory || [])]);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                })
                dispatch(setNewClient({...CLIENTS_DATA.newClient, communicationHistory: cloneIt}));
                dispatch(resetNewCommunicationHistory());
            }
        },
        update: (data, id) => {
            if (!ACTIVITY.saveNewClient) dispatch(setSaveNewClient(true));

            if (data.date && (data.date === "")) {
                toast.error("Date is mandatory field.");
            } else if (data.time && (data.time === "")) {
                toast.error("Time  is mandatory field.");
            } else {
                const cloneIt = CLIENTS_DATA.newClient.communicationHistory.slice();
                const rowIndex = cloneIt.findIndex((el) => String(el.no) === String(id));
                if (rowIndex >= 0) {
                    cloneIt[rowIndex] = {...cloneIt[rowIndex], ...data};
                    dispatch(setNewClient({...CLIENTS_DATA.newClient, communicationHistory: cloneIt}));
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex, rowData) => {
            if (!ACTIVITY.saveNewClient) dispatch(setSaveNewClient(true));

            const cloneIt = structuredClone(CLIENTS_DATA.newClient.communicationHistory);
            const idx = cloneIt.findIndex((el) => String(el.no) === String(rowData.no));
            if (idx >= 0) {
                cloneIt.splice(idx, 1);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                })
                dispatch(setNewClient({...CLIENTS_DATA.newClient, communicationHistory: cloneIt}));
            }
        }
    }

    const getDisplayData = () => {
        let data = (CLIENTS_DATA.newClient?.communicationHistory || []).slice();

        if (communicationHistoryFilters?.dateFrom) data = data.filter((el) => moment(el.date) > moment(communicationHistoryFilters.dateFrom));
        if (communicationHistoryFilters?.dateTo) data = data.filter((el) => moment(el.date) < moment(communicationHistoryFilters.dateTo));
        if (communicationHistoryFilters?.subject?.length > 0) data = data.filter((el) => communicationHistoryFilters.subject.includes(el.subject));

        return data;
    }

    return (
        <div>
            <Row>
                <Col sm={6} md={4}>
                    <DateBox
                        name="dateFrom"
                        selected={communicationHistoryFilters?.dateFrom}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateFrom')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateFrom')}
                    />
                </Col>
                <Col sm={6} md={4}>
                    <DateBox
                        name="dateTo"
                        selected={communicationHistoryFilters?.dateTo}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateTo')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateTo')}
                    />
                </Col>
                <Col sm={6} md={4}>
                    <Dropdown
                        multiSelect={true}
                        label={t('ClientsNewCommunicationHistoryEdit.subject')}
                        name="subject"
                        options={subjectsOptions}
                        key={communicationHistoryFilters.subject}
                        defaultValue={subjectsOptions.filter((el) => communicationHistoryFilters?.subject?.includes(el.value))}
                        onChange={(e) => handleOnFilterChange(e, 'msdd', 'subject')}
                    />
                </Col>
            </Row>
            <EditableTable
                className="client-communication-history"
                tableName="Client Communication History"
                allowActions={true}
                key={incrKey}
                actionButtons={{
                    edit: false,
                    print: false,
                    export: false,
                    delete: true,
                }}
                allowFilter={false}
                allowBulkActions={false}
                allowPrintResults={false}
                columns={chColumns}
                allowInsertRowFromTop={true}
                allowFilterTable={false}
                data={getDisplayData()}
                onUpdate={tableActions}
                enableNewRowCheckbox={true}
            />
        </div>
    )
}

export default NewClientCommunicationHistory;
